// utils/http.js
import axios from 'axios';

// 创建 Axios 实例
const http = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_API_BASE_URL,
  timeout: 30000,                  // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: process.env.NODE_ENV === 'development', // 开发环境允许携带跨域 Cookie
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 在请求头中添加 Authorization Token
    console.log('请求路径:', config.url);
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('请求错误：', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => response.data, // 直接返回数据
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 401:
          console.warn('未授权，跳转至登录页');
          window.location.href = '/login';
          break;
        case 403:
          console.error('禁止访问：', data.message || '您没有权限访问该资源');
          break;
        case 404:
          console.error('资源未找到：', data.message || '请求的资源不存在');
          break;
        case 500:
          console.error('服务器错误：', data.message || '服务器内部错误');
          break;
        default:
          console.error('未知错误：', data.message || '发生了未知错误');
      }
    } else if (error.request) {
      console.error('无响应数据：', error.request);
    } else {
      console.error('请求配置错误：', error.message);
    }
    return Promise.reject(error);
  }
);

export default http;
